import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  const c = light ? "#FFFFFF" : "#050505";
  return (
    <Link to="/" data-testid="logo-home-link" className={`flex items-center gap-2.5 ${className}`}>
      <svg width="26" height="26" viewBox="0 0 40 40" fill="none" className="shrink-0">
        <path d="M20 2 L38 34 L20 26 Z" fill={c} />
        <path d="M20 2 L2 34 L20 26 Z" fill={c} opacity="0.55" />
        <path d="M2 34 L38 34 L20 26 Z" fill={c} opacity="0.8" />
      </svg>
      <span className="font-display font-semibold text-[19px] tracking-tight leading-none" style={{ color: c }}>
        TetraLab<span style={{ color: "#D4FF00" }}>.</span>
      </span>
    </Link>
  );
};
